import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles/checkoutCTAButton.scss';

import LocalSpinner from '../../shared/components/LocalSpinner';
import { Button } from 'dibs-elements/exports/Button';

const CheckoutCTAButton = ({
    label,
    customClass = '',
    size = 'large',
    dataTn = '',
    disabled = false,
    marginTop = false,
    marginBottom = false,
    pullRight = false,
    isBlocked,
    isSaving = false,
    onClick,
    isApplePayButton,
}) => {
    if (isApplePayButton) {
        return (
            <div className={styles.applePayButtonContainer}>
                <Button
                    className={classNames(styles.applePayButton, {
                        [styles.applePayIsSaving]: isSaving,
                        [styles.applePayIsDisabled]: isBlocked || disabled || isSaving,
                    })}
                    onClick={e => !isBlocked && onClick(e)}
                >
                    {isSaving && <LocalSpinner inline />}
                </Button>
            </div>
        );
    }

    return (
        <Button
            className={classNames({
                [styles.button]: true,
                [styles.defaultWidth]: !customClass,
                [styles.defaultCursor]: isBlocked,
                [styles.marginTop]: marginTop,
                [styles.marginBottom]: marginBottom,
                [styles.pullRight]: pullRight,
                [styles.disabled]: disabled,
                [customClass]: true,
            })}
            size={size}
            dataTn={dataTn}
            onClick={e => !isBlocked && onClick(e)}
        >
            {isSaving && <LocalSpinner inline />}
            {!!label && <span>{label}</span>}
        </Button>
    );
};

CheckoutCTAButton.propTypes = {
    label: PropTypes.node,
    customClass: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    dataTn: PropTypes.string,
    disabled: PropTypes.bool,
    marginTop: PropTypes.bool,
    marginBottom: PropTypes.bool,
    pullRight: PropTypes.bool,
    isBlocked: PropTypes.bool,
    isSaving: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    isApplePayButton: PropTypes.bool,
};

export default CheckoutCTAButton;
